export default __webpack_public_path__ + "static/media/PersonHold3.492e24b8.svg";